import { ValidationPopupArrowIcon } from "../atoms";
import { ChevronLeft, ChevronRight } from "../icons";

export const ValidationPopupArrows = () => {
  return (
    <div className="flex items-center justify-center gap-4">
      {[ChevronLeft, ChevronRight].map((Icon) => (
        <ValidationPopupArrowIcon key={Icon.name}>
          <Icon />
        </ValidationPopupArrowIcon>
      ))}
    </div>
  );
};
